import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/bg_404.svg'


const _hoisted_1 = { class: "style1 radius-view1" }

export function render(_ctx, _cache) {
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      type: "flex",
      align: "middle",
      justify: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 24,
          style: {"text-align":"center"}
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              src: _imports_0,
              style: {"width":"150px"}
            }, null, -1)
          ])),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createElementVNode("div", { style: {"text-align":"center","font-size":"12px","color":"#C0C4CC"} }, " 哦吼，页面丢失了 ", -1)
          ])),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}